(function () {
  'use strict';

  angular
    .module('salesTarget')
    .config(config);

	  function config($stateProvider) {
		$stateProvider.state('salesTarget', {
			url : '/sales-target',
			views : {
				'salesTargetView' : {
					templateUrl : 'sales-target/views/sales-target.tpl.html',
					controller : 'salesTargetCtrl',
					controllerAs : 'salesTarget'
				}
			}
		});
	}
}());
